<ng-content />

@if (active()) {
    <div class="spinner" @fadeAnimation [style.min-height.px]="minHeight()">
        <nz-spin [nzTip]="!showTip() ? null : ('common.processing' | translate)" nzSimple></nz-spin>
    </div>
}
